export default "__VITE_PUBLIC_ASSET__4b19d866__"